// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"64d08be6ff7121208a4f","293":"daa4bb44fd29a4db7041","518":"f6c495b5528bfe196a18","779":"84911514645bb3c62f02"}[chunkId] + ".js";
};